import {
  HTTP_USERGROUP_SUCCESS,
  HTTP_USERGROUP_FETCHING,
  HTTP_USERGROUP_FAILED
} from '../constants';

const initialState = {
  result: null,
  isFatching: false,
  isError: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_USERGROUP_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_USERGROUP_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_USERGROUP_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };

    default:
      return state;
  }
};
